import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M21.9977 20.0004c1.0999 0 1.9998.9 1.9998 1.9998S23.0975 24 21.9977 24H1.9997C.9 24 0 23.1 0 22.0002s.9-1.9998 1.9998-1.9998zM13.9985 3.2522l3.7497 3.7496-9.859 9.849c-.09.1-.22.15-.35.15H4.4995c-.28 0-.5-.22-.5-.5V13.461c0-.14.05-.26.15-.36zM16.9582.2925a.9958.9958 0 011.4099 0l2.3397 2.3397c.39.39.39 1.02 0 1.4099L18.748 6.0019l-3.7496-3.7496z"
  }],
  circles: []
};
var BorderColorIcon = function BorderColorIcon(props) {
  return renderIcon(props, iconType);
};
export { BorderColorIcon };